var map = {
	"./IMG_2300.jpg": 970,
	"./IMG_2689.JPG": 219,
	"./asztal.jpg": 998,
	"./baratok.JPG": 774,
	"./box_utan.JPG": 938,
	"./boxban.JPG": 480,
	"./evfordulo.jpg": 499,
	"./feheren.JPG": 509,
	"./furdo.jpg": 735,
	"./indulas_haza.jpg": 54,
	"./itthon.jpg": 551,
	"./kanul.jpg": 558,
	"./kanul_gyulladas.jpg": 49,
	"./karacsony.jpg": 184,
	"./karacsony_mi.jpg": 523,
	"./kemo.jpg": 431,
	"./kopaszon.jpg": 924,
	"./korhazi_toltodes.jpg": 172,
	"./logo.png": 678,
	"./logo.svg": 576,
	"./me_before.png": 255,
	"./me_before1.png": 902,
	"./most.jpg": 346,
	"./mutet_utan.JPG": 900,
	"./noverem_korhaz.jpg": 243,
	"./noverem_udvar.jpg": 370,
	"./picc-line.jpg": 929,
	"./seta.jpg": 710,
	"./szentendre.jpg": 213,
	"./telefonzsinor.jpg": 473,
	"./transzplant_konzultacio.JPG": 661,
	"./transzplant_utan.JPG": 626,
	"./transzplantacio.jpg": 60,
	"./ujra_korhaz.jpg": 535,
	"./utolso_toltodes.jpg": 430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;